@import './../global.scss';

:host {
  display: block;
}

.answer__feedback {
  border-top: 1px dashed currentColor;
}

.feedback__button {
  color: currentColor;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: .425em;
  font-size: .85em;
  background: rgba(255, 255, 255, 0);
  cursor: pointer;
}

.feedback__confirmation {
  margin-bottom: 0;
  font-weight: bold;
}

.feedback__button:hover {
  background: rgba(255, 255, 255, 0.5);
}

.feedback__button:active,
.feedback__button:focus {
  color: currentColor;
}

.feedback__button--upvote {
  margin-right: 1em;
}

.feedback__text {
  margin-top: 1em;
}

.thumb-up,
.thumb-down {
  height: 1.3em;
  width: 1.3em;
}